// extracted by mini-css-extract-plugin
export default {"pagination":"CustomPagination_pagination__xtOm5","selectPagination":"CustomPagination_selectPagination__QgGpQ"};